import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class extends Controller {
  static values = {
    enableTime: Boolean,
    dateFormat: String,
    time24hr: Boolean
  }

  connect() {
    const enableTime = this.enableTimeValue || false

    // Campo só-data: remove a hora de um value "Y-m-d H:i".
    if (this.element.value && this.element.value.includes(" ") && !enableTime) {
      this.element.value = this.element.value.split(" ")[0]
    }

    const dateFormat  = this.dateFormatValue || (enableTime ? "Y-m-d H:i" : "Y-m-d")
    const altFormat   = enableTime ? "d/m/Y H:i" : "d/m/Y"
    const placeholder = enableTime ? "dd/mm/aaaa hh:mm" : "dd/mm/aaaa"
    const maxLen      = enableTime ? 16 : 10

    this.picker = flatpickr(this.element, {
      locale: Portuguese,
      enableTime,
      dateFormat,
      altInput: true,
      altFormat,
      time_24hr: this.time24hrValue || true,
      allowInput: true,
      disableMobile: true,
      onReady: (_dates, _str, instance) => {
        if (!instance.altInput) return
        instance.altInput.setAttribute("maxlength", maxLen)
        instance.altInput.setAttribute("inputmode", "numeric")
        instance.altInput.setAttribute("placeholder", placeholder)

        // Máscara: insere / automaticamente ao digitar
        // setTimeout garante que roda após o handler interno do flatpickr (allowInput: true)
        instance.altInput.addEventListener("input", (e) => {
          const el = e.target
          setTimeout(() => {
            const cursor = el.selectionStart
            const prev = el.value
            const maxDigits = enableTime ? 12 : 8
            let digits = prev.replace(/\D/g, "")
            if (digits.length > maxDigits) digits = digits.slice(0, maxDigits)

            let masked = digits
            if (!enableTime) {
              if (digits.length > 2) masked = digits.slice(0, 2) + "/" + digits.slice(2)
              if (digits.length > 4) masked = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4)
            } else {
              if (digits.length > 2) masked = digits.slice(0, 2) + "/" + digits.slice(2)
              if (digits.length > 4) masked = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4)
              if (digits.length > 8) masked = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8) + " " + digits.slice(8)
              if (digits.length > 10) masked = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8) + " " + digits.slice(8, 10) + ":" + digits.slice(10)
            }

            if (masked !== prev) {
              el.value = masked
              const diff = masked.length - prev.length
              el.setSelectionRange(cursor + diff, cursor + diff)
            }
          }, 0)
        })

        // Ao sair do campo, força parse do valor digitado
        instance.altInput.addEventListener("blur", () => {
          let val = instance.altInput.value.trim()

          // Dígitos puros sem separador: 10072005 → 10/07/2005
          if (!enableTime && /^\d{8}$/.test(val)) {
            val = `${val.slice(0, 2)}/${val.slice(2, 4)}/${val.slice(4)}`
            instance.altInput.value = val
          }
          // Com hora: 1007200514 → 10/07/2005 14 (incompleto), 100720051430 → 10/07/2005 14:30
          if (enableTime && /^\d{12}$/.test(val)) {
            val = `${val.slice(0, 2)}/${val.slice(2, 4)}/${val.slice(4, 8)} ${val.slice(8, 10)}:${val.slice(10)}`
            instance.altInput.value = val
          }

          if (val.length === (enableTime ? 16 : 10)) {
            instance.setDate(val, true, altFormat)
          }
        })

        instance.altInput.addEventListener("keydown", (e) => {
          if (e.ctrlKey || e.metaKey || e.altKey) return
          if (/^[a-zA-ZÀ-ÿ]$/.test(e.key)) e.preventDefault()
        })
      }
    })

    this.boundOpen = () => this.picker.open()

    // Abre ao clicar no ícone (input-group-text)...
    this.iconEl = this.element.closest(".input-group")?.querySelector(".input-group-text")
    this.iconEl?.addEventListener("click", this.boundOpen)

    // ...e ao clicar na label do campo.
    if (this.element.id) {
      this.labelEl = document.querySelector(`label[for="${this.element.id}"]`)
      this.labelEl?.addEventListener("click", this.boundOpen)
    }
  }

  disconnect() {
    this.iconEl?.removeEventListener("click", this.boundOpen)
    this.labelEl?.removeEventListener("click", this.boundOpen)
    if (this.picker) this.picker.destroy()
  }
}